import { tryRequest } from 'shared/utilities';
import axios from 'axios';

const version = '/api/v1';

export default {
  getAllRecordings(projectId) {
    return axios({
      method: 'get',
      url: `${version}/recording?projectId=${projectId}`,
    });
  },
  getRecording(recordingId) {
    return axios({
      method: 'get',
      url: `${version}/recording/${recordingId}`,
    });
  },
  getEvents(recordingId, start, end) {
    return axios({
      method: 'get',
      url: `${version}/event?recordingId=${recordingId}&start=${start.toISOString()}&end=${end.toISOString()}`,
    });
  },
  updateRecording(recordingId, payload) {
    return tryRequest(axios.patch(`${version}/recording/${recordingId}`, payload));
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/recordings/api.js